<!-- US-001 B-006: Tela publica de pagamento do acordo -->
<div class="acordo-publico-container">
    <div class="acordo-publico-card">

        <!-- Header -->
        <div class="acordo-header">
            <img *ngIf="logoUrl" [src]="logoUrl" alt="Logo da escola" class="acordo-logo-escola">
            <h2>Acordo de Pagamento</h2>
            <p class="acordo-header-nome" *ngIf="nomeUnidade">{{ nomeUnidade }}</p>
        </div>

        <!-- Loading -->
        <div *ngIf="loading" class="acordo-loading">
            <mat-spinner diameter="48"></mat-spinner>
            <p>Carregando dados do acordo...</p>
        </div>

        <!-- Erro de conexao -->
        <div *ngIf="!loading && erro" class="acordo-msg erro">
            <mat-icon>error_outline</mat-icon>
            <h3>Erro ao carregar</h3>
            <p>Não foi possível carregar os dados do acordo. Tente novamente mais tarde.</p>
        </div>

        <!-- Link invalido -->
        <div *ngIf="!loading && !erro && isInvalido()" class="acordo-msg invalido">
            <mat-icon>link_off</mat-icon>
            <h3>Link inválido</h3>
            <p>Este link de pagamento não foi encontrado ou é inválido.</p>
        </div>

        <!-- Acordo CANCELADO -->
        <div *ngIf="!loading && !erro && isCancelado()" class="acordo-msg cancelado">
            <mat-icon>cancel</mat-icon>
            <h3>Acordo cancelado</h3>
            <p>Este acordo foi cancelado. Entre em contato com o atendimento.</p>
        </div>

        <!-- Acordo EXPIRADO -->
        <div *ngIf="!loading && !erro && isExpirado()" class="acordo-msg expirado">
            <mat-icon>schedule</mat-icon>
            <h3>Link expirado</h3>
            <p>Este link expirou. Solicite um novo acordo.</p>
        </div>

        <!-- Acordo PAGO (status inicial da API) -->
        <div *ngIf="!loading && !erro && isPago() && !pagamentoSucesso" class="acordo-msg pago">
            <mat-icon>check_circle</mat-icon>
            <h3>Pagamento confirmado</h3>
            <p>Pagamento já confirmado. Obrigado!</p>
        </div>

        <!-- Tela de sucesso pos-pagamento -->
        <div *ngIf="pagamentoSucesso" class="acordo-msg pago">
            <mat-icon>check_circle</mat-icon>
            <h3>Pagamento realizado com sucesso!</h3>
            <div class="sucesso-info">
                <div class="sucesso-linha" *ngIf="transacaoId">
                    <span class="sucesso-label">Número da transação:</span>
                    <strong>#{{ transacaoId }}</strong>
                </div>
                <div class="sucesso-linha">
                    <span class="sucesso-label">Data/Hora:</span>
                    <strong>{{ dataHoraPagamento | date:'dd/MM/yyyy \'às\' HH:mm' }}</strong>
                </div>
                <div class="sucesso-linha">
                    <span class="sucesso-label">Valor pago:</span>
                    <strong>{{ valorFinal | currency:'BRL':'symbol':'1.2-2' }}</strong>
                </div>
                <p class="sucesso-obs">Um comprovante será enviado para o e-mail cadastrado.</p>
            </div>
        </div>

        <!-- Acordo PENDENTE (ativo) -->
        <ng-container *ngIf="!loading && !erro && isPendente()">

            <!-- Saudacao -->
            <div class="acordo-saudacao" *ngIf="nomeAluno">
                <p>Olá, <strong>{{ nomeAluno }}</strong>!</p>
                <p>Segue abaixo os dados para pagamento do seu acordo — <strong>{{ nomeUnidade }}</strong>.</p>
            </div>

            <!-- Resumo de valores -->
            <div class="acordo-valores">
                <div class="valor-linha">
                    <span>Valor original:</span>
                    <strong>{{ valorOriginal | currency:'BRL':'symbol':'1.2-2' }}</strong>
                </div>
                <div class="valor-linha desconto" *ngIf="percentualDesconto > 0">
                    <span>Desconto ({{ percentualDesconto }}%):</span>
                    <strong>- {{ valorDesconto | currency:'BRL':'symbol':'1.2-2' }}</strong>
                </div>
                <div class="valor-linha total">
                    <span>Valor a pagar:</span>
                    <strong>{{ valorFinal | currency:'BRL':'symbol':'1.2-2' }}</strong>
                </div>
            </div>

            <!-- Parcelas -->
            <div class="acordo-parcelas" *ngIf="parcelas.length > 0">
                <h4>Parcelas incluídas no acordo</h4>
                <table class="parcelas-tabela">
                    <tr *ngFor="let p of parcelas">
                        <td class="parcela-desc">{{ p.descricao }}</td>
                        <td class="parcela-venc">{{ p.dataVencimento | date:'dd/MM/yyyy' }}</td>
                        <td class="parcela-valor">{{ p.valor | currency:'BRL':'symbol':'1.2-2' }}</td>
                    </tr>
                </table>
            </div>

            <!-- Toggle forma de pagamento -->
            <div class="metodo-pagamento-toggle">
                <h4>Forma de pagamento</h4>
                <div class="toggle-buttons">
                    <button mat-raised-button
                            [color]="metodoSelecionado === 'pix' ? 'primary' : ''"
                            (click)="trocarParaPix()"
                            [disabled]="loadingPix">
                        <mat-icon>qr_code</mat-icon> Pix
                    </button>
                    <button mat-raised-button
                            [color]="metodoSelecionado === 'cartao' ? 'primary' : ''"
                            (click)="trocarParaCartao()">
                        <mat-icon>credit_card</mat-icon> Cartão
                    </button>
                </div>
            </div>

            <!-- Loading Pix -->
            <div *ngIf="loadingPix" class="acordo-loading">
                <mat-spinner diameter="32"></mat-spinner>
                <p>Gerando Pix...</p>
            </div>

            <!-- SECAO PIX -->
            <ng-container *ngIf="metodoSelecionado === 'pix' && !loadingPix">
                <div class="acordo-cartao" *ngIf="erroPix">
                    <div class="erro-cartao">
                        <mat-icon>warning</mat-icon>
                        {{ erroPix }}
                    </div>
                </div>

                <div class="acordo-qrcode" *ngIf="qrCodeBase64">
                    <h4>Escaneie o QR Code para pagar</h4>
                    <img [src]="'data:image/png;base64,' + qrCodeBase64"
                         alt="QR Code para pagamento Pix no valor de {{ valorFinal | currency:'BRL':'symbol':'1.2-2' }}"
                         class="qrcode-img">
                </div>

                <div class="acordo-pix" *ngIf="pixCopiaECola">
                    <h4>Pix Copia e Cola</h4>
                    <div class="pix-codigo">
                        <textarea readonly rows="3">{{ pixCopiaECola }}</textarea>
                        <button mat-raised-button color="primary"
                                (click)="copiarPix()"
                                aria-label="Copiar codigo Pix">
                            <mat-icon>content_copy</mat-icon>
                            {{ pixCopiado ? 'Copiado!' : 'Copiar' }}
                        </button>
                    </div>
                    <p class="pix-instrucao" *ngIf="!qrCodeBase64">
                        Copie o código acima e cole no aplicativo do seu banco para efetuar o pagamento.
                    </p>
                </div>
            </ng-container>

            <!-- SECAO CARTAO -->
            <ng-container *ngIf="metodoSelecionado === 'cartao'">
                <div class="acordo-cartao">

                    <!-- Instrucao -->
                    <div class="instrucao-cartao">
                        <mat-icon>info_outline</mat-icon>
                        <p>Preencha os dados do seu cartão de crédito para concluir o pagamento.</p>
                    </div>

                    <!-- Valor a pagar (display, nao input) -->
                    <div class="valor-display">
                        <span class="valor-display-label">Valor do pagamento</span>
                        <span class="valor-display-valor">{{ valorFinal | currency:'BRL':'symbol':'1.2-2' }}</span>
                    </div>

                    <!-- Visual do cartao -->
                    <app-draw-credit #drawCreditCard [cardData]="cardData"></app-draw-credit>

                    <form [formGroup]="cartaoForm" (ngSubmit)="pagarComCartao()">

                        <mat-form-field appearance="outline" class="campo-full">
                            <mat-label>Número do cartão</mat-label>
                            <input matInput formControlName="numero"
                                   mask="0000 0000 0000 0000"
                                   placeholder="0000 0000 0000 0000"
                                   (focus)="drawCreditCard?.unflip()">
                            <mat-error>Informe o número do cartão</mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="campo-full">
                            <mat-label>Nome impresso no cartão</mat-label>
                            <input #nomeInput matInput formControlName="nome"
                                   maxlength="50"
                                   appTitlecase
                                   (focus)="drawCreditCard?.unflip()">
                            <mat-hint align="end">{{ nomeInput.value?.length || 0 }}/50</mat-hint>
                            <mat-error>Informe o nome como aparece no cartão</mat-error>
                        </mat-form-field>

                        <div class="campos-row">
                            <mat-form-field appearance="outline" class="campo-mes">
                                <mat-label>Mês</mat-label>
                                <mat-select formControlName="mes" (selectionChange)="drawCreditCard?.unflip()">
                                    <mat-option *ngFor="let m of meses" [value]="m.value">{{ m.label }}</mat-option>
                                </mat-select>
                                <mat-error>Mês</mat-error>
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="campo-ano">
                                <mat-label>Ano</mat-label>
                                <mat-select formControlName="ano" (selectionChange)="drawCreditCard?.unflip()">
                                    <mat-option *ngFor="let a of anosValidade" [value]="a">{{ a }}</mat-option>
                                </mat-select>
                                <mat-error>Ano</mat-error>
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="campo-cvv">
                                <mat-label>CVV</mat-label>
                                <input matInput formControlName="codigo"
                                       mask="0009"
                                       placeholder="000"
                                       maxlength="4"
                                       (focus)="drawCreditCard?.flip()">
                                <mat-error>Informe o CVV</mat-error>
                            </mat-form-field>
                        </div>

                        <mat-form-field appearance="outline" class="campo-full" *ngIf="maxParcelas > 1">
                            <mat-label>Parcelas</mat-label>
                            <mat-select formControlName="parcelas">
                                <mat-option *ngFor="let p of opcoesParcelamento" [value]="p">
                                    {{ p }}x de {{ (valorFinal / p) | currency:'BRL':'symbol':'1.2-2' }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <!-- RF-09: CPF do titular do cartão -->
                        <div class="cpf-titular-section">
                            <mat-checkbox formControlName="informarCpfTitular">
                                Informar CPF do titular do cartão
                            </mat-checkbox>
                            <mat-form-field appearance="outline" class="campo-full"
                                            *ngIf="cartaoForm.get('informarCpfTitular').value">
                                <mat-label>CPF do titular</mat-label>
                                <input matInput formControlName="cpfTitular"
                                       mask="000.000.000-00" placeholder="000.000.000-00">
                            </mat-form-field>
                        </div>

                        <div class="erro-cartao" *ngIf="erroCartao">
                            <mat-icon>warning</mat-icon>
                            {{ erroCartao }}
                        </div>

                        <button mat-raised-button color="primary" type="submit"
                                class="btn-pagar-cartao"
                                [disabled]="cartaoForm.invalid || processandoCartao">
                            <mat-spinner *ngIf="processandoCartao" diameter="20" class="spinner-inline"></mat-spinner>
                            <mat-icon *ngIf="!processandoCartao">credit_card</mat-icon>
                            {{ processandoCartao ? 'Processando...' : cartaoForm.get('parcelas').value > 1 ? 'Pagar ' + cartaoForm.get('parcelas').value + 'x de ' + (valorFinal / cartaoForm.get('parcelas').value | currency:'BRL':'symbol':'1.2-2') : 'Pagar com Cartão' }}
                        </button>

                        <!-- Badge de seguranca -->
                        <div class="seguranca-badge">
                            <mat-icon>lock</mat-icon>
                            <span>Pagamento seguro com criptografia SSL</span>
                        </div>

                    </form>
                </div>
            </ng-container>

            <!-- Dados do cedente (escola) -->
            <div class="acordo-cedente" *ngIf="nomeUnidade">
                <h4>Dados do beneficiário</h4>
                <div class="cedente-info">
                    <p class="cedente-nome"><strong>{{ nomeUnidade }}</strong></p>
                    <p *ngIf="cnpjUnidade"><span class="cedente-label">CNPJ:</span> {{ cnpjUnidade }}</p>
                    <p *ngIf="enderecoUnidade"><span class="cedente-label">Endereço:</span> {{ enderecoUnidade }}</p>
                    <p *ngIf="telefoneUnidade"><span class="cedente-label">Telefone:</span> {{ telefoneUnidade }}</p>
                </div>
            </div>

        </ng-container>

    </div>
</div>
